<template>
<v-container class="py-0 px-0">
  <v-row wrap>
    <v-col v-for="(item, idx) in navItems" :key="idx" cols="12" class="py-1">
      <v-card v-if="shouldDisplay(item)" :disabled="item.disabled" color="blue5" @click="handleCardClick(item)">
        <v-card-title>
          {{ item.title }}
          <v-spacer />
          <v-icon color="blue3">{{ item.icon }}</v-icon>
        </v-card-title>
        <v-card-subtitle>
          {{ item.description }}
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
  <v-dialog v-model="showCoveragesDialog" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-card-title :style="style" class="px-2">
        <v-btn icon @click="showCoveragesDialog = false">
          <v-icon color="white">mdi-keyboard-backspace</v-icon>
        </v-btn>
        Coverages
      </v-card-title>
      <v-card-text class="px-0 py-0">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="px-0 py-0">
              <GeneralInfo :lob="lob" />
            </v-col>
            <v-col cols="12" class="px-0 py-0">
              <v-divider />
              <LineOfBusinessCoverages />
            </v-col>
          </v-row>
        </v-container>

      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-model="showVehiclesDialog" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-card-title :style="style" class="px-2">
        <v-btn icon @click="showVehiclesDialog = false">
          <v-icon color="white">mdi-keyboard-backspace</v-icon>
        </v-btn>
        Vehicles
      </v-card-title>
      <v-card-text class="px-0 py-0">
        <v-container fluid>
          <v-row>
            <v-col cols="12" class="px-0 py-0">
              <GeneralInfo :lob="lob" />
            </v-col>
            <v-col cols="12" class="px-0 py-0">
              <v-divider />
              <Vehicles />
            </v-col>
          </v-row>
        </v-container>

      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
</template>

<style>
  .tileSheet {
    justify-content: center;
    align-items: center;
  }
</style>

<script>
import GeneralInfo from '@/components/Client/LineOfBusiness/GeneralInfo.vue';
import LineOfBusinessCoverages from '@/components/Client/LineOfBusiness/LineOfBusinessCoverages.vue';
import Vehicles from '@/components/Client/LineOfBusiness/Vehicles/Vehicles.vue';
import { mapState } from 'vuex';

export default {
  name: 'Policies',
  components: { LineOfBusinessCoverages, GeneralInfo, Vehicles },
  props: {
    lob: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      showCoveragesDialog: false,
      showVehiclesDialog: false,
      style: {
        'background-color': this.$vuetify.theme.themes.light.integrity,
        color: 'white'
      },
      navItems: [
        {
          title: 'Coverages',
          icon: 'mdi-shield-check',
          action: () => { this.showCoveragesDialog = !this.showCoveragesDialog; },
          isVisible: () => this.displayCoverages
        },
        {
          title: 'Vehicles',
          icon: 'mdi-car',
          action: () => { this.showVehiclesDialog = !this.showVehiclesDialog; },
          isVisible: () => this.displayVehicles
        }
      ],
      vehicleCodes: [9, 10, 14, 28, 69, 77]
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    viewMoreText: function () {
      return this.viewingMore ? 'View Less' : 'View More';
    },
    policyTitle: function () {
      if ((this.policy || null) === null) {
        return '';
      }
      return `${this.policy.displayOrder + 1}-${this.policy.title}`;
    },
    displayCoverages: function () {
      return true;
    },
    displayVehicles: function () {
      return this.vehicleCodes.includes(parseInt(this.lobCode));
    }
  },
  methods: {
    shouldDisplay: function (item) {
      return item.isVisible();
    },
    handleCardClick: function (item) {
      if ((item.route || null) !== null) {
        if (item.route === '') return;
        this.$router.push(this.$route.path + item.route);
      }

      if ((item.action || null) !== null) {
        item.action();
      }
    }
  }
};
</script>
